










































import Vue from "vue";
import { pdf_state } from "../data/pdf/state.pdf";
import { PdfReport } from "../data/pdf/model";
import {
  DrillDownMenuItem,
  UseDrillDownMenu,
} from "@/components/root/drilldown-menu/drilldown-menu.state";
import { UseModal } from "@/components/root/modal";
import ReportTemplateSectionsModalVue from "./ReportTemplateSectionsModal.vue";
import VirtualTable from "@/components/table/VirtualTable.vue";
import PdfTableRow from "./PdfTableRow.vue";
import { table_config } from "./table.config";
import { onBeforeUnmount, onMounted } from "@vue/composition-api";
import { EventBus } from "@/eventbus";
import { emptyFn } from "@/fp";
import { download_report } from "../data/pdf/api";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import TemplatesTable from "./templates-table/TemplatesTable.vue";
import GenerateReportOptionsModalVue from "../GenerateReportOptionsModal.vue";
import RegenerateReportModalVue from "./RegenerateReportModal.vue";
import { NotificationsManager } from "@/components/root/navbar/notifications/NotificationManager";
import {
  reportDetailsHtml,
  trackReportEvent,
} from "../data/report-analytics";
export default Vue.extend({
  components: {
    VirtualTable,
    SimpleNavTabs,
    TemplatesTable,
  },
  setup(_, { root: { $router } }) {
    const { pdf_reports, tabs, current_tab, set_current_tab } = pdf_state;

    const show_menu = async (payload: {
      event: MouseEvent;
      item: PdfReport;
    }) => {
      const { event, item } = payload;
      const download_item = {
        isCategory: false,
        name: "Download report",
        disable: false,
        isPremium: false,
        subItems: [],
        icon: "Download",
        action: "download",
      };
      const download_pptx_item = {
        isCategory: false,
        name: "Download PowerPoint",
        disable: false,
        isPremium: false,
        subItems: [],
        icon: "Download",
        action: "download_pptx",
      };
      const delete_item = {
        isCategory: false,
        name: "Delete report",
        disable: false,
        isPremium: false,
        subItems: [],
        icon: "Trash",
        action: "delete",
      };
      const inspect_item = {
        isCategory: false,
        name: "View report details",
        disable: false,
        isPremium: false,
        subItems: [],
        icon: "Detection",
        action: "inspect_details",
      };
      const retry_item = {
        isCategory: false,
        name: "Retry report",
        disable: false,
        isPremium: false,
        subItems: [],
        icon: "Report",
        action: "retry",
      };
      const template = pdf_state.report_templates.items.value.find(
        (d) => d.id == item.template_id
      );
      // fail closed: only offer a PowerPoint download when we can confirm
      // this report is a slide-deck report (it 404s otherwise).
      // Keep this list in step with SLIDE_DECK_QUESTION_IDS in the generator's
      // page-formats.ts — a slide deck the generator renders but this list
      // omits silently loses its PowerPoint option.
      const slide_deck_question_ids = [
        "aggregated.monthly_management_report",
        "aggregated.quarterly_management_report",
      ];
      // The report's own sections say it, and they are all there is when an
      // Executive Reports deck ran without a saved template. The service
      // stores a section's question as `id`, whatever PdfReportSection says.
      const is_slide_deck_report =
        !!template?.sections?.some((s) => slide_deck_question_ids.includes(s.id)) ||
        (item.sections || []).some((s) =>
          slide_deck_question_ids.includes(
            (s as { id?: string }).id || s.section_id
          )
        );
      let menu: DrillDownMenuItem[];
      if ((item as PdfReport).status == "completed") {
        menu = is_slide_deck_report
          ? [download_item, download_pptx_item, inspect_item, delete_item]
          : [download_item, inspect_item, delete_item];
      } else {
        // status == 'failed'
        menu = [retry_item, inspect_item, delete_item];
      }
      const menu_res = await UseDrillDownMenu().show({
        event: event,
        menu,
      });
      if (menu_res.didUserSelectedAnAction) {
        switch (menu_res.actionSelected) {
          case "show_report_template":
            UseModal().show(ReportTemplateSectionsModalVue, template);
            break;
          case "download":
            NotificationsManager.remove(item.id);
            await download_report(item.id, item.name);
            trackReportEvent("downloaded", {
              report_id: item.id,
              report_name: item.name,
              report_type: "pdf",
              report_subtype: item.is_scheduled ? "scheduled" : "template",
              template_id: item.template_id,
              status: item.status,
              parameters: item.sections.map((section) => ({
                type: section.question,
                value: {
                  data_source: section.data_source,
                  application: section.application,
                  time: section.time,
                },
              })),
              data_sources: item.runtime.data_sources,
              source: "pdf_reports_table",
            });
            break;
          case "retry":
            await pdf_state.generate_report_from_template({
              name: item.name,
              template_id: item.template_id,
              tracking_action: "retried",
              sections: item.sections.map((section) => ({
                id: section.section_id,
                question: section.question,
                data_source: section.data_source,
                application: section.application,
                parameters: [],
                time: section.time,
              })),
            });
            break;
          case "inspect_details":
            trackReportEvent("details_inspected", {
              report_id: item.id,
              report_name: item.name,
              report_type: "pdf",
              report_subtype: item.is_scheduled ? "scheduled" : "template",
              template_id: item.template_id,
              status: item.status,
              parameters: item.sections.map((section) => ({
                type: section.question,
                value: {
                  data_source: section.data_source,
                  application: section.application,
                  time: section.time,
                },
              })),
              data_sources: item.runtime.data_sources,
              source: "pdf_reports_table",
            });
            UseModal().showSimple({
              title: "Report Details",
              desc: reportDetailsHtml({
                report_id: item.id,
                report_name: item.name,
                report_type: "pdf",
                report_subtype: item.is_scheduled ? "scheduled" : "template",
                status: item.status,
                parameters: item.sections.map((section) => ({
                  type: section.question,
                  value: {
                    data_source: section.data_source,
                    application: section.application,
                    time: section.time,
                  },
                })),
                data_sources: item.runtime.data_sources,
              }),
              submitBtnText: "Close",
              cancelBtnText: "",
            });
            break;
          case "download_pptx":
            NotificationsManager.remove(item.id);
            download_report(item.id, item.name, "pptx");
            break;
          case "delete":
            pdf_state.delete_report(item);
            break;
          default:
            break;
        }
      }
    };

    const generate_report = async () => {
      if (current_tab.value.id == "Reports") {
        await show_generate_report_options();
      } else {
        $router.push({ name: "ReportGenerator", query: { action: "new" } });
      }
    };

    const show_generate_report_options = async () => {
      if (pdf_state.report_templates.items.value.length === 0) {
        $router.push({ name: "ReportGenerator", query: { action: "new" } });
      } else {
        const res = await UseModal().show(GenerateReportOptionsModalVue);
        if (res.type == "success") {
          if (res.msg == "new") {
            $router.push({ name: "ReportGenerator", query: { action: "new" } });
          } else {
            // create from template
            UseModal().show(RegenerateReportModalVue, res.msg);
          }
        }
      }
    };

    const subs = {
      show_menu: emptyFn(),
    };
    onMounted(() => {
      subs.show_menu = EventBus.listen("showReportMenu", show_menu);
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      PdfTableRow,
      generate_report,
      table_config,
      pdf_reports,
      reports: pdf_reports.items,
      is_show_reports_loader: pdf_state.is_loading,
      tabs,
      current_tab,
      set_current_tab,
    };
  },
});
